import { createTheme } from '@mui/material/styles';

const defaultTheme = createTheme();

const theme = createTheme({
    palette: {
        primary: {
            main: '#3498db',
            light: '#5dade2',
            dark: '#2980b9',
            contrastText: '#fff'
        },
        secondary: {
            main: '#64748B', // よりソフトなグレー
            light: '#94A3B8',
            dark: '#475569',
            contrastText: '#fff'
        },
        background: {
            default: '#F8FAFC',
            paper: '#FFFFFF'
        },
        text: {
            primary: '#334155',
            secondary: '#64748B'
        },
        grey: {
            50: '#F8FAFC',
            100: '#F1F5F9',
            200: '#E2E8F0',
            300: '#CBD5E1',
            400: '#94A3B8',
            500: '#64748B',
            600: '#475569',
            700: '#334155',
            800: '#1E293B',
            900: '#0F172A'
        }
    },
    typography: {
        fontFamily: [
            'Noto Sans JP',
            'Roboto',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif'
        ].join(','),
        h1: {
            fontSize: '2.5rem',
            fontWeight: 700,
            lineHeight: 1.2
        },
        h2: {
            fontSize: '2rem',
            fontWeight: 600,
            lineHeight: 1.3
        },
        h3: {
            fontSize: '1.5rem',
            fontWeight: 600,
            lineHeight: 1.4
        },
        body1: {
            fontSize: '1rem',
            lineHeight: 1.5
        },
        button: {
            textTransform: 'none',
            fontWeight: 600
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '20px',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)'
                }
            }
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px'
                    }
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    borderRadius: '20px',
                },
            }
        },
        MuiPopover: {
            styleOverrides: {
                paper: {
                    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                    borderRadius: '12px',
                },
            },
        },
    },
    shape: {
        borderRadius: 8
    },
    shadows: [
        ...defaultTheme.shadows,
        '0px 3px 5px -1px rgba(0,0,0,0.2)', // elevation 1
        '0px 5px 8px -2px rgba(0,0,0,0.2)', // elevation 2
    ],
});

export default theme; 